export const info = [
    // "<strong>Language</strong>: Please Enter your info only in English.",
    // "<strong>Name Field</strong>: Enter your Surname followed by your Name e.g. 'DOE JOHN' or 'DOE JANE'",
    "<strong>Mobile Phone Field</strong>: Mobile number must start with country phone code. Find your country code from Country Code field.",
    "<strong>Required Fields</strong> are marked with *.",
]